<template>
  <div class="handle">
    <v-icon class="drag__icon">mdi-drag</v-icon>
    <p v-if="control.extra === ''">
      {{ $t('components.questionnaires.inputs.defaultText') }}
    </p>
    <p v-else>{{ control.extra }}</p>
  </div>
</template>

<script>
import inputMixin from '@/components/questionnaires/fields/inputs/inputMixin'

export default {
  name: 'RichTextInput',
  mixins: [inputMixin],
  data () {
    return {
      type: 'text',
      editPanel: 'RichTextEditPanel'
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "grab";
</style>
